if (!customElements.get("toggle-element-class")) {
    class ToggleElementClass extends HTMLElement {
        constructor() {
            super();
            this.options = {
                toggleClass: "toggle--is-active",
                toggleTriggerClass: "",
                target: "body",
                onHover: false,
                hoverDelay: 0,
                preventDefault: true,
                stopPropagation: true
            };
            if (this?.dataset?.options) {
                const dataOptions = JSON.parse(this.dataset.options);
                this.options = {
                    ...this.options,
                    ...dataOptions
                }
            }
            this.reducer = {
                click: e => this.debounceClickEvent(e),
                mouseEnter: e => this.debouncedOnMouse(e, "add"),
                mouseLeave: e => this.debouncedOnMouse(e, "remove")
            };
            this.construct()
        }
        construct() {
            this.target = document.querySelector(this.options.target);
            if (!this.target) {
                return false
            }
            this.removeEventListener("click", this.reducer.click);
            this.addEventListener("click", this.reducer.click);
            if (this.options.onHover) {
                this.removeEventListener("mouseenter", this.reducer.mouseEnter);
                this.addEventListener("mouseleave", this.reducer.mouseLeave)
            }
        }
        debounceClickEvent(e) {
            if (!e) {
                return false
            }
            this.preventDefault(e);
            this.stopPropagation(e);
            this.toggle()
        }
        debouncedOnMouse(e, type) {
            if (!e) {
                return false
            }
            const debouncer = debounce((type => {
                switch (type) {
                    case "add":
                        this.add();
                        break;
                    case "remove":
                        this.remove();
                        break;
                    default:
                        this.toggle();
                        break
                }
            }), this.options.hoverDelay);
            debouncer(type)
        }
        preventDefault(e) {
            if (this.options.preventDefault) {
                e.preventDefault()
            }
        }
        stopPropagation(e) {
            if (this.options.stopPropagation) {
                e.stopPropagation()
            }
        }
        add() {
            const {
                toggleClass,
                toggleTriggerClass
            } = this.options;
            if (this.target) {
                this.target.classList.add(toggleClass)
            }
            if (toggleClass === "collection-filter-is-open") {
                document.querySelector(".filter-options__sort").classList.remove("collapsible-is-open")
            }
            if (toggleTriggerClass) {
                this.classList.add(toggleTriggerClass)
            }
            if (toggleClass == "header__search--is-active") {
                document.querySelector("[data-header] [data-search-input]").focus()
            }
        }
        remove() {
            const {
                toggleClass,
                toggleTriggerClass
            } = this.options;
            if (this.target) {
                this.target.classList.remove(toggleClass)
            }
            if (toggleTriggerClass) {
                this.classList.remove(toggleTriggerClass)
            }
        }
        toggle() {
            const {
                toggleClass
            } = this.options;
            if (!this.target) {
                return false
            }
            if (!this.target.classList.contains(toggleClass)) {
                this.add()
            } else {
                this.remove()
            }
        }
    }
    window.ToggleElementClass = ToggleElementClass;
    customElements.define("toggle-element-class", ToggleElementClass)
}
//# sourceMappingURL=toggle-element-class.js.map